import { CenteredModal } from '@app/core';
import { LoginViaCodeContent } from './LoginViaCodeContent';
import { Account } from '@app/api';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onRequestClose: () => any;
  email?: string;
  participantId?: string;
  onSuccess?: (account: Account) => any;
}

export const LoginViaCodeModal = ({
  email,
  isOpen,
  onRequestClose,
  participantId,
  onSuccess,
}: Props) => {
  const { t } = useTranslation('common');
  return (
    <CenteredModal
      title={t('login.emailValidationCode.title')}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <LoginViaCodeContent
        hideTitle
        email={email}
        displayed={isOpen}
        participantId={participantId}
        onSuccess={onSuccess}
      />
    </CenteredModal>
  );
};
